// ADD API URLS BELOW
export const API_URLS = {
    SEARCH_GLOBAL: '/api/search/globalsearch',
    SEARCH_SUGGESTIONS: '/api/search/suggest',
    SEARCH_NOTICES: '/api/search/notices',
    SEARCH_PUBLICATIONS: '/api/search/publications',
    SEARCH_PODCASTS: '/api/search/podcasts',
    SEARCH_BLOGS: '/api/search/blogs',
    SEARCH_NEWS: '/api/search/news',
    SEARCH_WEBINARS: '/api/search/webinars',
    SEARCH_EVENTS: '/api/search/events',
    SEARCH_PEOPLE: '/api/search/people',
    SEARCH_TEAM: '/api/search/team',
};
